import { defineStore } from 'pinia'

export interface FeatureFlagsState {
  flags: Set<string>;
}

export const useFeatureFlagsStore = defineStore('featureFlags', {
  state: (): FeatureFlagsState => ({
    flags: new Set<string>()
  }),
  actions: {
    setFeatureFlags(flags: string[]) {
      this.flags = new Set(flags);
    },
    clearFlags() {
      this.flags.clear();
    }
  },
  getters: {
    hasFeature: (state) => (flag: string) => flag && state.flags.has(flag),

    // Specific feature flag getters - add new ones as they are created
    hasJiraCloudIntegration: (state) => state.flags.has('jira-cloud-integration'),
    hasTextDevChat: (state) => state.flags.has('text-dev-chat'),
    hasSingleUserMode: (state) => state.flags.has('single-user-mode'),
    hasAudioInteraction: (state) => state.flags.has('audio-interaction'),
    hasWebSocketFileUpload: (state) => state.flags.has('websocket-file-upload'),
    hasAutodeskThreeLeggedOauth: (state) => state.flags.has('autodesk-three-legged-oauth')
  }
})